const Vue = require('vue')
import apihelper from './apihelper'
import config from '@/util/config'

export default {
    select() {
        return apihelper.get("/address/select");
    },
    getedit(p) {
        return apihelper.get("/address/get", p);
    },
    save(p) {
        return apihelper.post("/address/save", p);
    },
    remove(p) {
        return apihelper.get("/address/remove", p);
    },
    setdefault(p) {
        return apihelper.get("/address/SetDefault", p);
    }
}